/*
    Breadcrumb app: update 'All Canes' link  
    implemented: layout/theme.liquid
*/
document.addEventListener("DOMContentLoaded", function () {

    function whenAvailable(DOM_element, callback, number_of_trys) {
        number_of_trys += 1;
        const appEl = document.querySelector(DOM_element)
        const interval = 1000; 

        console.log( number_of_trys)
        const int = window.setTimeout(function() {
            if (appEl) {
                callback(appEl);
                clearInterval(int)
            } else {
                number_of_trys <= 10 ? whenAvailable(DOM_element, callback, number_of_trys) : console.log("Reached limit for number_of_trys", number_of_trys);
            }
        }, interval);
    }

    whenAvailable(".ba-breadcrumb", function(el) {
        console.log("Breadcrumbs app loaded", el)

        const all_canes_anchor = el.querySelector('[href="/collections"]')
        //console.log(all_canes_anchor)

        all_canes_anchor.setAttribute('href', '/collections/shop-all-canes')
        all_canes_anchor.setAttribute('title', 'Shop All Canes')
    },0);

})